import React, { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AddIcon, DeleteIcon } from './BuilderComponents';

export default function ScheduleSection({numGroups, setNumGroups, activityList, onTimesListChange, timesList }) {
  const [time, setTime] = useState("");

  useEffect(() => {
    // Set the local state 'time' when 'timesList' changes
    setTime(timesList);
  }, [timesList]);


  const handleAddColumn = () => {
    setNumGroups(numGroups + 1);
  };

  const handleDeleteColumn = () => {
    if (numGroups > 1) {
      setNumGroups(numGroups - 1);
    }
  };

  const handleTimeChange = (index, value) => {
    const newTimesList = [...time];
    newTimesList[index] = JSON.parse(JSON.stringify(value.format('h:mm A  ')));
    setTime(newTimesList);
    onTimesListChange(newTimesList);
  }

  return (
    <>
    {/* Header Row and Cells */}
     <tr style={{ display: 'flex' }}>
        <td style={{ borderTop: 'none', minWidth: '20rem' /* Set a fixed width */, overflow: 'hidden' }}>
          <h5 style={{ marginLeft: '1rem', marginRight: '5rem', fontWeight: 'bold' }}>Rotation</h5>
        </td>
        <td style={{ borderTop: 'none' }}>
          <h5 style={{ marginRight: '10rem', fontWeight: 'bold'}}>Rotation Start Times</h5>
        </td>
        {Array.from({ length: numGroups }, (_, index) => (
          <td style={{ borderTop: 'none' }} key={index}>
            <h5 style={{ paddingRight: '3rem', fontWeight: 'bold' }}>
              Group {index + 1} {index === numGroups - 1}
            </h5>
          </td>
        ))}
        <td style={{ borderTop: 'none', flex: '2', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <AddIcon onClick={handleAddColumn} />
          <DeleteIcon onClick={handleDeleteColumn} />
        </td>
      </tr>
    {/* Body Row and Cells */}
    {activityList.map((activity, index) => (
  // Only render the schedule row if the activity has not been deleted
      !activity.isDeleted && (
        <tr style={{ display: 'flex' }} key={index}>
          <td style={{ borderTop: 'none', minWidth: '20rem' }}>
            <h5 style={{ position: 'sticky', top: '0', marginLeft: '1rem', fontWeight: 'bold' }}>
              {activity.maxGroups === '' ? activity.activity : `Activity ${activity.activityNumber}`}
            </h5>
          </td>
          <td style={{ borderTop: 'none'}}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label={`Rotation ${index + 1} Start Time`}
                onChange={(newTime) => handleTimeChange(index, newTime)}
              />
            </LocalizationProvider>
          </td>
          <td style={{ borderTop: 'none', flex: '2', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>   
          </td>
        </tr>
      )
    ))}
    </>
  );
}